import React, { useState } from "react";
import { Btn, Card, Field, Overline } from "@/components/kit";
import { Subs } from "@/components/Subs";
import { useAuth } from "@/context/AuthContext";
import { api, apiError } from "@/lib/api";
import { toast } from "@/components/ui/sonner";

export default function Cover() {
  const { user, patchUser } = useAuth();
  const [title, setTitle] = useState(user?.cover_title || "");
  const [intention, setIntention] = useState(user?.cover_intention || "");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/api/profile", { cover_title: title, cover_intention: intention });
      patchUser({ cover_title: data.cover_title, cover_intention: data.cover_intention });
      toast.success("Saved");
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto em-fade-up" data-testid="cover-page">
      <Overline>Keepsake</Overline>
      <h1 className="font-serif text-4xl sm:text-5xl text-ink mt-2">Your Cover</h1>
      <p className="text-inksoft mt-3 mb-8 leading-relaxed">
        Add a personal title and a short intention. These appear on the cover of any month or year you
        export as a PDF keepsake.
      </p>

      {/* Live preview (warm paper) */}
      <div className="rounded-2xl p-8 text-center mb-8" style={{ background: "#fbf7ef", color: "#2b2620" }}>
        <div style={{ fontFamily: "Arial, sans-serif", textTransform: "uppercase", letterSpacing: 4, fontSize: 11, color: "#a8895c" }}>
          The Emergence Journal
        </div>
        <div className="font-serif" style={{ fontSize: 34, color: "#1c1712", marginTop: 12 }}>
          <Subs>{title || "ME₀ : ME₁₁"}</Subs>
        </div>
        <div style={{ fontStyle: "italic", color: "#6b6154", marginTop: 12 }}>
          {intention ? `\u201c${intention}\u201d` : "Your intention will appear here."}
        </div>
      </div>

      <Card className="space-y-4">
        <Field label="Cover title" placeholder="e.g. My Year of Becoming" maxLength={80} value={title}
          onChange={(e) => setTitle(e.target.value)} data-testid="cover-title" />
        <Field label="A short intention" textarea placeholder="One sentence to carry through the year…"
          maxLength={300} value={intention} onChange={(e) => setIntention(e.target.value)}
          data-testid="cover-intention" inputClassName="min-h-[90px]" />
        <Btn onClick={save} disabled={saving} data-testid="cover-save">{saving ? "Saving…" : "Save cover"}</Btn>
      </Card>
    </div>
  );
}
